import { fireOperationalEvent } from '@atlassian/teams-common/analytics';
import { AnalyticsAction, AnalyticsActionSubject } from './index';
export const triggerAnalyticsForLoadedPeople = (action, createAnalyticsEvent, status, error) => {
  fireOperationalEvent(createAnalyticsEvent, {
    actionSubject: AnalyticsActionSubject.PEOPLE_MENU_LINK,
    action: action === 'succeeded' ? AnalyticsAction.SUCCEEDED : AnalyticsAction.FAILED,
    attributes: {
      status,
      error: (error === null || error === void 0 ? void 0 : error.message) || JSON.stringify(error)
    }
  });
};
export const triggerAnalyticsForLoadedTeam = (action, createAnalyticsEvent, status, error) => {
  fireOperationalEvent(createAnalyticsEvent, {
    actionSubject: AnalyticsActionSubject.TEAM_MENU_LINK,
    action: action === 'succeeded' ? AnalyticsAction.SUCCEEDED : AnalyticsAction.FAILED,
    attributes: {
      status,
      error: (error === null || error === void 0 ? void 0 : error.message) || JSON.stringify(error)
    }
  });
};